<template>
	<div class="drawer">
		<el-drawer size="700px" title="选择优惠券" :visible.sync="drawerStatus" id="addShop" @close='handleClose' :append-to-body="true">
			<!-- <el-radio-group v-model="curCardId" style="width:500px;margin:100px 100px;">
				<el-radio :label="item._no" v-for="(item,index) in list" :key="index" style="display: flex;height: 30px;">
					<div style="display: flex;justify-content: space-between;width:500px">
						<span>{{item.coupon_name}} ( {{item._no}} )</span>
						<span>{{$public.getDiscountType(item.apply_range.order_type)}}券</span>
						<span v-if="item.activity_type===1">
							满{{item.money_top}}元可用
						</span>
						<span v-if="item.activity_type===2">
							满{{item.rebate_top}}元可用，
							<span v-if="item.rebate_limit>0">最高抵扣{{item.rebate_limit}}元</span>
							<span v-else></span>
						</span>
					</div>
				</el-radio>
			</el-radio-group> -->
			<div style="margin:0 0 20px 30px;"> <el-input size="mini" style="width: 150px" v-model="scanningCodeInput" @keyup.enter.native="clickInput" clearable
                placeholder="请录入劵码">
            </el-input></div>
			<div style="margin:0 0 20px 30px;">
				<div style="margin-bottom:20px;">
					商品总金额：<span style="color:#FE2D2D">￥{{ money }}</span>
				</div>
				<div>
					券后应付：<span style="color:#F5882A">￥{{ newMoney }}</span>
				</div>
			</div>
			<el-table :data="filtrateList.length!=0 ? filtrateList : list" style="height: 100%;" class="tableBox">
				<el-table-column label="优惠券名称" width="130">
					<template slot-scope="scope">
						<span>{{ scope.row.coupon_name }}</span>
					</template>
				</el-table-column>
				<el-table-column label="面额" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.activity_type==1">{{ scope.row.money_reduce }}</span>
						<span v-if="scope.row.activity_type==2">{{ scope.row.rebate*10 }}折</span>
					</template>
				</el-table-column>
				<el-table-column label="核销码" width="100">
					<template slot-scope="scope">
						<el-radio v-model="radio" :label="scope.row._no"
							@change="changeRadio(scope.row)"></el-radio>
					</template>
				</el-table-column>
				<el-table-column label="使用规则" width="130">
					<template slot-scope="scope">
						<span v-if="scope.row.activity_type==1">满 {{ scope.row.money_top }} 减{{ scope.row.money_reduce }} </span>
						<span v-if="scope.row.activity_type==2">满{{ scope.row.rebate_top }} 最高抵扣{{ scope.row.rebate_limit}} </span>
					</template>
				</el-table-column>
				<el-table-column label="类别" width="130">
					<template slot-scope="scope">
						<span>{{ $public.getDiscountType(scope.row.apply_range.order_type) }}券</span>
					</template>
				</el-table-column>
				<el-table-column label="有效期至" width="100">
					<template slot-scope="scope">
						{{ $public.FTime(scope.row.use_end_time, "YYYY-MM-DD") }}
					</template>
				</el-table-column>
			</el-table>
			<div style="height: 80px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="handleClose">取消</div>
				<div class="btnItem submit" @click="submitCode">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
export default {
	data() {
		return {
			drawerStatus: false,
			radio: '',
			curCard: {},
			list: [],
			newMoney: 0,
			scanningCodeInput: '',
            filtrateList:[]
		}
	},
	computed: {
	},
	props: {
		userId: {
			default: ''
		},
		state: {
			default: false
		},
		money: {
			default: 0
		},
		goodsList: {
			default: () => {
				return []
			}
		},
		type: {       // 1 商品 2 洗美 3 病例 4 疫苗驱虫 5 医疗服务套餐 6  寄养 7 挂号 8 活体 9 虚拟类 10 订金
			default: -1
		}
	},
	watch: {
		state(n) {
			this.drawerStatus = n;
			if (n) {
				this.getList()
				this.newMoney = this.money;
				this.radio = ''
				// this.changeRadio();
			}
		}
	},
	mounted() {
		console.log(this.goodsList, 'goodsListgoodsListgoodsList');
	},
	methods: {
		handleClose() {
			this.$emit('submit', { type: 'close', card: this.curCard, newMoney: this.newMoney })
		},
		 // 筛选
		 clickInput() {
            if (this.scanningCodeInput) {
                let value = this.scanningCodeInput
                let arr = this.list
                let filterArr = (arr, value) => {
                    return arr.filter(item => {
                        for (let key in item) {
                            if (item[key] === value) {
                                return true;
                            }
                        }
                        return false;
                    });
                }
                let result = filterArr(arr, value);
                this.filtrateList = result 
				if(this.filtrateList.length==0){
					this.$message({
          message: "未搜索到优惠券",
          type: "error",
        });
				}
				console.log(this.filtrateList,'///////');
            }

        },
		// 获取列表
		getList() {
			let params = {
				"member_id": this.userId,
				status: 1,  // -1:不限 0：不可用，1：未使用 2：已使用 3：已过期
				order_type: this.type,//  0不限 1. 商品  2.洗美  3.病例 4. 疫苗驱虫 5.医疗服务 6 寄养 7 挂号 8活体 9虚拟类 10定金 
				product_goods_list:[]
			}
			let param = []
			for (let i = 0; i < this.goodsList.length; i++) {
				param.push({
					param_id: this.goodsList[i].goodsId,
					param_sku_id: this.goodsList[i].skus,
					category_id: this.goodsList[i].categoryId,
					packing_way_id: this.goodsList[i].unitId,
					custom_code: '',
					num: this.goodsList[i].num,
					price: this.goodsList[i].price,
				})
			}
			params.product_goods_list = param
			let loading = this.$loading()
			//
			this.$http.post( process.env.VUE_APP_apiHost + 'api/Order/GetCanUseCouponList', params).then(res => {
				loading.close()
				if (res.code == 0) {
					this.list = res.data
					console.log('优惠券列表', res, '11111');

				}
			})
		},

		// getList() {
		// 	let params = {
		// 		"memberId": this.userId,
		// 		status:1,  // -1:不限 0：不可用，1：未使用 2：已使用 3：已过期
		// 		couponType:this.type,//  0不限 1. 商品  2.洗美  3.病例 4. 疫苗驱虫 5.医疗服务 6 寄养 7 挂号 8活体 9虚拟类 10定金 
		// 		"pageIndex": 1,
		// 		"pageSize": 1000,
		// 	}
		// 	this.list=[]
		// 	let loading = this.$loading()
		// 	this.$http.get('/api/Member/CouponList', params).then(res => {
		// 		loading.close()
		// 		if (res.code == 0) {
		// 			let list = res.data.data;
		// 			console.log('优惠券列表','11111');
		// 			for(let i=0;i<list.length;i++){
		// 				if(list[i].apply_range!==null&&list[i].apply_range.order_type!==null){
		// 					if(list[i].apply_range.order_type.indexOf(this.type)>-1){
		// 					this.list.push(list[i])
		// 				}
		// 				}

		// 			}
		// 		}
		// 	})
		// },
		changeRadio(row) {
			
			this.curCard = this.$public.getMatchingItem(this.list, '_no', this.radio)
			console.log(row,this.curCard.money_reduce,'rowwww');
			// this.newMoney = row.money;
			if (this.curCard.activity_type === 1) {
				this.newMoney = this.$public.jian(this.money, this.curCard.money_reduce);
			} else if (this.curCard.activity_type === 2) {
				console.log(this.newMoney,this.$public.jian(1, this.curCard.rebate),'qqqqq');
				let yh = this.$public.cheng(this.money, this.$public.jian(1, this.curCard.rebate));
				if (this.curCard.rebate_limit > 0) {
					if (yh > this.curCard.rebate_limit) {
						yh = this.curCard.rebate_limit
					}
				}
				this.newMoney = this.$public.jian(this.money, yh);
			} else if (this.curCard.activity_type === 3) {
				console.log(this.curCard.canList[0])
				this.newMoney = this.$public.jian(this.money, this.curCard.canList[0].originalPrice);
			}
		},
		submitCode() {
			console.log(this.curCard,'curCard');
			console.log(this.newMoney,'newMoney');
			this.$emit('submit', { type: 'submit', card: this.curCard, newMoney: this.newMoney,money: this.money })
		},
	},
}
</script>

<style scoped lang="scss">#addShop {
	::v-deep .el-drawer__header {
	  margin-bottom: 90px;
	}
	::v-deep .el-drawer__body {
	  height: calc(100% - 55px);
	  overflow-y: auto;
	}
  }
  
.btnBox {
	width: 100%;
	font-size: 14px;
	color: #fff;
	line-height: 40px;
	display: flex;
	position: absolute;
	bottom: 0;
	z-index: 10;

	.btnItem {
		text-align: center;
		width: 100%;
		background-color: #D6D6D6;
		cursor: pointer;

		&.submit {
			background-color: $mainColor;
		}
	}
}</style>
